import type { ModelLead } from '@app/api/Leads/types';

export const mergeLeads = (prevLeads: ModelLead[], nextLeads: ModelLead[]) => {
  const leadById = new Map(prevLeads.map((lead) => [lead.Id, lead]));

  nextLeads.forEach((lead) => leadById.set(lead.Id, lead));

  return Array.from(leadById.values());
};
